import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 12L19 12M19 12L12 5M19 12L12 19", stroke: "#EAECF0", strokeWidth: 1.67, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowRightIcon);
export { ForwardRef as ReactComponent };
